import { ROUTES } from '@dashboard/router/routeNames'

export default [
  {
    name: ROUTES.ADS,
    path: 'ads',
    component: () => import('./pages/AdsIndex.vue'),
    meta: {
      title: 'Ads'
    }
  }
]
